import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
const BusinessRoute = () => {
    const token = useSelector(state => state?.userData?.access_token)
    const brandAccount = useSelector(state => state?.userData?.brandAccount)
    return (
        <>
            {(token && !brandAccount?.id) ? <Outlet /> : (token && brandAccount?.id) ? <Navigate to="/issues" /> : <Navigate to="/" />}
        </>
    )
}
export default BusinessRoute;